import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export enum ScrollDirectionEnum {
  up = 'up',
  down = 'down',
  left = 'left',
  right = 'right',
}

export const TRACKING_SCROLLED_SCHEMA = Object.freeze({
  SCROLL_DIRECTION: ScrollDirectionEnum,
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_SCROLLED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SCROLLED_SCHEMA);

export class ScrolledTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.scrolled;
  }

  get properties() {
    return this.toJS();
  }
}
